import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
} from '@angular/core';

import { Observable } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Store, select } from '@ngrx/store';
import { UserState } from '@account-users/user/state/user/user.reducer';

import {
  getUserInvitationLink,
  getUserIsLoadingInvitationLink,
} from '@account-users/user/state';

@Component({
  selector: 'app-invitation-link',
  templateUrl: './invitation-link.component.html',
  styleUrls: ['./invitation-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationLinkComponent implements OnInit {
  public invitationLink$: Observable<string>;
  public isLoadingInvitationLink$: Observable<boolean>;

  constructor(
    private readonly store: Store<UserState>,
    public readonly activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.invitationLink$ = this.store.pipe(select(getUserInvitationLink));
    this.isLoadingInvitationLink$ = this.store.pipe(
      select(getUserIsLoadingInvitationLink),
    );
  }
}
